import MainMenu from '../menu/mainMenu';
import RightMenu from "../menu/rightMenu";
import { UserSession } from "../../models/user";
import { LoginStore } from '../../stores/LoginStore';

type Props = {
    user: UserSession;
    store: LoginStore;
}

const Header: React.FC<Props> = (props: Props) => {
    const { user, store } = props;
    return (   
        <>
            <header>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-xs-12 col-md-3 logo-container">                        
                            <img src="/img/logo-bppb.png" alt="BPPB Logo" width={210} />
                        </div>
                        <div className="col-xs-12 col-md-6 menu-container">
                            {user.authenticated && <MainMenu />}
                        </div>
                        <div className="col-xs-12 col-md-3 menu-container">      
                            <RightMenu user={user} store={store} />   
                        </div>
                    </div>
                </div>
            </header>
        </> 
    );
}

export default Header